module.exports = __webpack_public_path__ + "fonts/iconfont.2b8e30a1.woff";